import { FormGroup, FormControl } from "@angular/forms";
import { DateValidators } from "../../shared/validators/date.validators";

export class CapacityReportFormGroup extends FormGroup {
    constructor() {
        super({
            plantingDateRange: new FormControl(null, DateValidators.DateRangeValidator())
        });
    }

    public get plantingDateRangeFormControl(): FormControl {
        return <FormControl> this.get("plantingDateRange");
    }

    public get plantingDateRange(): Date[] {
        return this.plantingDateRangeFormControl && <Date[]> this.plantingDateRangeFormControl.value;
    }

    public get plantingStartDate(): Date {
        return this.plantingDateRange && this.plantingDateRange.length > 1 && this.plantingDateRange[0];
    }

    public get plantingEndDate(): Date {
        return this.plantingDateRange && this.plantingDateRange.length > 1 && this.plantingDateRange[1];
    }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/reporting/capacity-report-form/capacity-report-form.formgroup.ts